export function cleanInteger(val, positive) {
    if (positive === void 0) { positive = true; }
    if (val === null || val === undefined || val === "") {
        return null;
    }
    else {
        var valString = val + '';
        var num = Number(valString.replace(/[^\d]/g, ''));
        var isNegative = !positive && valString[0] == '-';
        if (isNegative) {
            num = -num;
        }
        return num;
    }
}
export function cleanDecimal(val, positive, decimals) {
    if (positive === void 0) { positive = true; }
    if (decimals === void 0) { decimals = 2; }
    if (val === null || val === undefined || val === "") {
        return null;
    }
    else {
        var valString = val + '';
        var intPartString = void 0;
        var decimalPartString = void 0;
        var decimalPointIndex = valString.indexOf('.');
        if (decimalPointIndex > 0) {
            intPartString = valString.substring(0, decimalPointIndex).replace(/[^\d]/g, '');
            decimalPartString = valString.substring(decimalPointIndex).replace(/[^\d]/g, '');
        }
        else {
            intPartString = valString.replace(/[^\d]/g, '');
        }
        if (intPartString.length == 0) {
            intPartString = "0";
        }
        var num = void 0;
        if (!decimalPartString || decimalPartString.length == 0) {
            num = Number(intPartString);
        }
        else {
            num = Number(intPartString + '.' + decimalPartString);
        }
        var isNegative = !positive && valString[0] == '-';
        if (isNegative) {
            num = -num;
        }
        var multiplier = Math.pow(10, decimals);
        return Math.round(num * multiplier) / multiplier;
    }
}
